import { HostFlowEnum } from '_/services/api/cfgCHType-flow-restrictions';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useFlowRestrictions = () => {
  const flowRestrictions = useSelector((state: any) => state.company.flowRestrictions);
  const categoryAssignments = useSelector((state: any) => state.host.categoryAssignments);

  return useMemo(() => {
    const isBlocked = (flow: HostFlowEnum): boolean => {
      if (!categoryAssignments?.length || !flowRestrictions?.length) return false;

      return categoryAssignments.every((assignment: any) =>
        flowRestrictions.some(
          (r: any) => r.cfgCHTypeId === assignment.cfgCHTypeId && r.flowIdentifier === flow
        )
      );
    };

    return {
      isQRcodeBlocked: isBlocked(HostFlowEnum.QRCODE),
      isVisitsBlocked: isBlocked(HostFlowEnum.VISITS),
      isCredentialingBlocked: isBlocked(HostFlowEnum.CREDENTIALING),
      isMeetingsBlocked: isBlocked(HostFlowEnum.MEETINGS),
      isSpaceManagementBlocked: isBlocked(HostFlowEnum.SPACE_MANAGEMENT),
    };
  }, [flowRestrictions, categoryAssignments]);
};
